import { COLORS } from "../lib/colors";

export default function MetricsBar({ data }) {
  if (!data) return null;

  const metrics = [
    { label: "Students in Pool", value: data.total_students },
    { label: "Active Recruiters", value: data.total_recruiters },
    { label: "Searches This Month", value: data.searches_this_month },
    { label: "CVs Viewed", value: data.views_this_month },
    { label: "CV Requests", value: data.total_cv_requests ?? 0 },
    { label: "Approval Rate", value: `${data.cv_approval_rate ?? 0}%` },
  ];

  const sc = data.status_counts || {};

  return (
    <div>
      <div className="metrics-grid" style={{
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: 12,
        marginBottom: 12,
      }}>
        {metrics.map(m => (
          <div key={m.label} style={{
            backgroundColor: COLORS.surface,
            border: `1px solid ${COLORS.border}`,
            borderRadius: 10,
            padding: "16px 18px",
          }}>
            <p style={{ fontSize: 12, color: COLORS.textMuted, marginBottom: 6 }}>{m.label}</p>
            <p style={{ fontSize: 24, fontWeight: 700, color: COLORS.text, margin: 0 }}>{m.value}</p>
          </div>
        ))}
      </div>
      <p style={{ fontSize: 13, color: COLORS.textSecondary }}>
        <span style={{ color: COLORS.green }}>●</span> {sc.active ?? 0} Active{" "}
        <span style={{ marginLeft: 12, color: COLORS.accent }}>●</span> {sc.hired ?? 0} Hired{" "}
        <span style={{ marginLeft: 12, color: COLORS.textMuted }}>●</span> {sc.inactive ?? 0} Inactive
      </p>
    </div>
  );
}
